import React from 'react';
import people1 from '../assets/Testimonials/people/1.jpg'
import people2 from '../assets/Testimonials/people/2.jpg'
import people3 from '../assets/Testimonials/people/3.jpg'
import people4 from '../assets/Testimonials/people/4.jpg'
import people5 from '../assets/Testimonials/people/5.jpg'
import people6 from '../assets/Testimonials/people/6.jpg'
import people7 from '../assets/Testimonials/people/7.jpg'
import people8 from '../assets/Testimonials/people/8.jpg'
import people9 from '../assets/Testimonials/people/9.jpg'
import people10 from '../assets/Testimonials/people/10.jpg'
import people11 from '../assets/Testimonials/people/11.jpg'
import people12 from '../assets/Testimonials/people/12.jpg'
import people13 from '../assets/Testimonials/people/13.jpg'
import people14 from '../assets/Testimonials/people/14.jpg'
import people15 from '../assets/Testimonials/people/15.jpg'
import SoldOutCard from '../components/SoldOutCard';
import '../styles/SoldOut.css';

const PeopleGrid = () => {
  const soldData = [
    {id: 1, peopleImg: people1,},
    {id: 2, peopleImg: people2,},
    {id: 3, peopleImg: people3,},
    {id: 4, peopleImg: people4,},
    {id: 5, peopleImg: people5,},
    {id: 6, peopleImg: people6,},
    {id: 7, peopleImg: people7,},
    {id: 8, peopleImg: people8,},
    {id: 9, peopleImg: people9,},
    {id: 10, peopleImg: people10,},
    {id: 11, peopleImg: people11,},
    {id: 12, peopleImg: people12,},
    {id: 13, peopleImg: people13,},
    {id: 14, peopleImg: people14,},
    {id: 15, peopleImg: people15,},

  ];

  return (
    <div className="sold-out-grid">
      {soldData.map(people => (
        <SoldOutCard
          key={people.id}
          soldOutImg={people.peopleImg}
        />
      ))}
    </div>
  );
};

export default PeopleGrid;